import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loudnessProgress: 0,
    loudnessIsProcessing: false,
    loudnessFiles: [],
    loudnessErrorMessage: '',
    loudnessLevel: -9,
    inputLoudnessLevel: -9,
    addLoudnessToFileNames: false,
    changeLoudness: true, // mirrors loudnessSettingsSlice's default
    loudnessCancelRequested: false,
    autoAnalyze: false,
};

const appSlice = createSlice({
    name: 'loudness',
    initialState,
    reducers: {
        setLoudnessProgress(state, action) {
            state.loudnessProgress = action.payload;
        },
        setLoudnessIsProcessing(state, action) {
            state.loudnessIsProcessing = action.payload;
        },
        resetLoudnessFilePath(state) {
            state.loudnessFiles = []
        },
        setLoudnessFiles(state, action) {
            state.loudnessFiles = action.payload;
        },
        setLoudnessErrorMessage(state, action) {
            state.loudnessErrorMessage = action.payload;
        },
        setLoudnessCancelRequested(state, action) {
            state.loudnessCancelRequested = action.payload;
        },
        setLoudnessAutoAnalyze(state, action) {
            state.autoAnalyze = action.payload;
        }
    },
});

export const {
    setLoudnessProgress,
    setLoudnessIsProcessing,
    resetLoudnessFilePath,
    setLoudnessFiles,
    setLoudnessErrorMessage,
    setLoudnessCancelRequested,
    setLoudnessAutoAnalyze
} = appSlice.actions;

export default appSlice.reducer;
